import { Dumbbell, BookOpen, Moon, Heart, GlassWater, type LucideIcon } from "lucide-react";

interface RoutineItem {
  id: string;
  text: string;
  icon: LucideIcon;
  color: string;
}

export const routines: RoutineItem[] = [
  {
    id: "1",
    text: "Exercise for 20 minutes daily to boost energy and mood",
    icon: Dumbbell,
    color:
      "bg-orange-50 dark:bg-orange-950 text-orange-600 dark:text-orange-400 border-orange-100 dark:border-orange-900",
  },
  {
    id: "2",
    text: "Practice mindful reading for 15 minutes to reduce stress",
    icon: BookOpen,
    color:
      "bg-blue-50 dark:bg-blue-950 text-blue-600 dark:text-blue-400 border-blue-100 dark:border-blue-900",
  },
  {
    id: "3",
    text: "Maintain a consistent sleep schedule for better recovery",
    icon: Moon,
    color:
      "bg-purple-50 dark:bg-purple-950 text-purple-600 dark:text-purple-400 border-purple-100 dark:border-purple-900",
  },
  {
    id: "4",
    text: "Drink 8 glasses of water daily for optimal hydration",
    icon: GlassWater,
    color:
      "bg-cyan-50 dark:bg-cyan-950 text-cyan-600 dark:text-cyan-400 border-cyan-100 dark:border-cyan-900",
  },
  {
    id: "5",
    text: "Take 10 minutes daily for self-care and mental well-being",
    icon: Heart,
    color:
      "bg-rose-50 dark:bg-rose-950 text-rose-600 dark:text-rose-400 border-rose-100 dark:border-rose-900",
  },
];
